import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  button& {\n    min-height: auto; /* Override button sizing due to sanitize.css */\n  }\n  cursor: pointer;\n  padding: 0;\n  position: absolute;\n  right: 12px;\n  top: ", ";\n  border: none;\n\n  svg {\n    display: block;\n  }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: ", ";\n  left: 12px;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  font-size: 12px;\n  margin-top: 8px;\n  color: ", ";\n  a {\n    color: inherit;\n    font-weight: 600;\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin-bottom: 8px;\n  min-height: 20px;\n  line-height: 1;\n  position: relative;\n\n  svg {\n    /* hack to optically align icon with text */\n    top: -1px;\n    position: relative;\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: 500;\n  font-size: 14px;\n  margin-right: 4px;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  max-height: ", ";\n  ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 40px;\n  padding-left: ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  height: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  ", "\n\n  ::placeholder {\n    color: ", ";\n  }\n\n  :disabled {\n    background: ", ";\n    color: ", ";\n\n    &::placeholder {\n      color: ", ";\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  color: ", ";\n  padding: 0 16px;\n  font-family: inherit;\n  border-radius: 3px;\n  box-sizing: border-box;\n  width: 100%;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { transparentize } from 'polished';
import { IconSearchAnimated } from '../Icons/aliases';
import { poppyRed, steel, white, whiteSmoke, cobaltBlue, mineShaft, lightSteel } from '../../styles/colors';

function getBorder(error) {
  return "\n    border: 1px solid ".concat(error ? poppyRed : steel, ";\n\n    ", "\n      :focus, &.docz-focus {\n        border: 1px solid ".concat(error ? poppyRed : cobaltBlue, ";\n        box-shadow: 0px 0px 0px 2px ").concat(transparentize(0.75, error ? poppyRed : cobaltBlue), ";\n        outline: none;\n      }\n    "), "\n  ");
}

export var InputContainer = styled.label(_templateObject());
export var SearchInputContainer = styled.div(_templateObject2());
export var BaseStyles = css(_templateObject3(), white, mineShaft);
export var BaseInput = styled.input(_templateObject4(), BaseStyles, function (_ref) {
  var error = _ref.error;
  return getBorder(error);
}, lightSteel, whiteSmoke, steel, steel);
export var Input = styled(BaseInput)(_templateObject5(), function (_ref2) {
  var small = _ref2.small;
  return small ? '14px' : '16px';
}, function (_ref3) {
  var small = _ref3.small;
  return small ? '32px' : '40px';
});
export var RoundedSearchInput = styled(Input)(_templateObject6(), function (_ref4) {
  var small = _ref4.small;
  return small ? '32px' : '40px';
});
export var TextAreaStyled = styled(BaseInput)(_templateObject7(), function (_ref5) {
  var maxHeight = _ref5.maxHeight;
  return maxHeight;
}, function (_ref6) {
  var resize = _ref6.resize;
  return !resize && 'resize: none;';
});
export var LabelText = styled.span(_templateObject8(), steel);
export var LabelContainer = styled.div(_templateObject9());
export var HelpText = styled.div(_templateObject10(), steel);
export var ErrorMessage = styled(HelpText)(_templateObject11(), poppyRed);
export var IconSearchStyled = styled(IconSearchAnimated)(_templateObject12(), function (_ref7) {
  var small = _ref7.small;
  return small ? '8px' : '10px';
});
export var CloseButton = styled.button(_templateObject13(), function (_ref8) {
  var small = _ref8.small;
  return small ? '8px' : '10px';
});